export default (): string => (new Date().getTime()).toString(36);